
namespace RioERP.Masters {
    export class TawkToChatColumns {
        static columnsKey = 'Masters.TawkToChat';
    }
}